import { toastPositions } from './positions';
import { unit } from '../../../styles/unit';

const positionStyle = position => {
  switch (position) {
    case toastPositions.TOP:
      return ['50%', unit(4), 'auto', 'auto', 'translateX(-50%)'];

    case toastPositions.TOP_LEFT:
      return [unit(4), unit(4), 'auto', 'auto'];

    case toastPositions.TOP_RIGHT:
      return ['auto', unit(4), unit(4), 'auto'];

    case toastPositions.BOTTOM:
      return ['50%', 'auto', 'auto', unit(4), 'translateX(-50%)'];

    case toastPositions.BOTTOM_LEFT:
      return [unit(4), 'auto', 'auto', unit(4)];

    case toastPositions.BOTTOM_RIGHT:
      return ['auto', 'auto', unit(4), unit(4)];

    default:
      return ['50%', 'auto', 'auto', unit(4), 'translateX(-50%)'];
  }
};

export { positionStyle };